import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueHighLightJS from 'vue-highlight.js'
import xml from 'highlight.js/lib/languages/xml'
import shell from 'highlight.js/lib/languages/shell'
import plaintext from 'highlight.js/lib/languages/plaintext'
import optimapp from './plugins/optimapp'

import VueClipboard from 'v-clipboard'

Vue.config.productionTip = false

import 'highlight.js/styles/a11y-dark.css'

// Load highlight.js
Vue.use(VueHighLightJS, {
  languages: {
    xml,
    shell,
    plaintext,
    optimapp
  }
})

Vue.use(VueClipboard)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
